
<component
    :is="componentName"
    :filter-element="filterElement"
></component>
